import { HttpInterceptorFn } from '@angular/common/http';
import { getCurrentEnv } from '../core/http/env-utils';

/**
 * Ensures SEO calls carry the right Authorization when using share links.
 * - If a shareable token exists for SEO (ai-audit share), set Authorization: token:<shareableToken>.
 * - Otherwise, do nothing and let AuthInterceptor attach the normal token.
 * - If Authorization already present, we skip.
 *
 * Works pre-rewrite (/seo/...) and post-rewrite (absolute env.seo URL).
 */
export const SeoHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.has('Authorization')) return next(req);

  const env = getCurrentEnv();
  const seoBase = env.seo || '';

  const pathOnly = (req.url.split('?')[0] || '').trim();
  const isPreRewrite = pathOnly.startsWith('/seo/');
  const isPostRewrite =
    typeof seoBase === 'string' && req.url.startsWith(seoBase);
  if (!isPreRewrite && !isPostRewrite) return next(req);

  const sharablePage =
    window.location.href.includes('share/ai-audit') ||
    window.location.href.includes('share/website-audit');

  const shareable =
    (sharablePage && sessionStorage.getItem('shareableToken')) || null;
  if (!shareable) return next(req); // AuthInterceptor will attach normal token

  const authValue = `token:${shareable}`;
  return next(req.clone({ setHeaders: { Authorization: authValue } }));
};
